import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const WebSubHeader = () => import(/* webpackChunkName: "4-feat-web-sub-header" */ './WebSubHeader');

const LoadableWebSubHeader: ComponentType = lazyLoadOnRender({ loader: WebSubHeader });
export default LoadableWebSubHeader;
